"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import AngleRightBold from "@/icons/angleRightBold.svg";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { getTranslation } from "@/i18n/get-translation";
import { IBlogResponse } from "@/types/blog.type";
import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "next/navigation";
import { getBlogs } from "@/services/blogs.service";
import SingleRecentPost from "@components/single-recent-post/single-recent-post";

interface IPostsData {
  title?: string;
  imgSrc?: any;
  href?: string;
  desc?: string;
  className?: string;
  slideWidth?: any;
}

interface IRecentPosts {
  locale: string;
  blogCategory: string;
}
const init = {
  data: [],
  meta: {
    pagination: {
      page: 0,
      pageSize: 0,
      pageCount: 0,
      total: 0,
    },
  },
};
export default function BlogRecentPosts({
  locale,
  blogCategory,
}: IRecentPosts) {
  const t = getTranslation(locale, "recentPosts");
  const j = getTranslation(locale, "innerSubCategories");
  const [blogs, setBlogs] = useState<IBlogResponse>(init);
  const handleFetchBlogs = useCallback(() => {
    const lang =
      locale.split("-")[0] === "en" ? "en" : `${locale.split("-")[0]}-LU`;
    getBlogs(lang, blogCategory !== j("all") ? blogCategory : null, false)
      .then((res: IBlogResponse) => {
        setBlogs(res);
      })
      .catch(console.log);
  }, [locale, blogCategory, j]);
  useEffect(() => {
    handleFetchBlogs();
  }, [blogCategory]);
  return (
    <div className="w-full px-20 max-md:px-7 pt-0 lg:pb-12 pb-10 relative overflow-hidden mb-8">
      {blogs.data.length ? (
        <h2 className="text-primary-800 font-medium xl:text-[2.1rem] lg:text-[1.7rem] text-[1.35rem] relative mb-6">
          {t("recentlyPosted")}
        </h2>
      ) : (
        ""
      )}
      <Swiper
        modules={[Navigation, Pagination]}
        spaceBetween={12}
        slidesPerView={1.2}
        navigation={{
          nextEl: ".next-slide",
          prevEl: ".prev-slide",
        }}
        pagination={true}
        breakpoints={{
          1399: {
            slidesPerView: 4,
          },
          1199: {
            slidesPerView: 3,
          },
          992: {
            slidesPerView: 2.2,
          },
        }}
        className="relative recentPostsSwiper"
      >
        {blogs.data.map((blog, key) => (
          <SwiperSlide key={key}>
            {blog?.attributes?.poster && (
              <SingleRecentPost
                href={`/${locale}/blog/${blog?.attributes?.slug}`}
                title={blog?.attributes?.title}
                imgUrl={`${
                  blog?.attributes?.poster?.data
                    ? blog?.attributes?.poster?.data?.attributes?.url
                    : "/images/clinic-image.webp"
                }`}
              />
            )}
          </SwiperSlide>
        ))}
        <div className="absolute z-10 -right-16 top-0 bg-slider-gradient h-full w-52 max-md:hidden"></div>
        <button className="prev-slide absolute top-[4.375rem] z-20 [&.swiper-button-disabled]:opacity-0 left-4 max-md:hidden">
          <div className="relative">
            <div className="bg-primary-500 rounded-full w-14 h-14 drop-shadow-[0px_14px_50px_#BE57DD]"></div>
            <AngleRightBold className="h-[1.375rem] absolute left-2/4 top-2/4 -translate-1/2 rotate-180" />
          </div>
        </button>
        <button className="next-slide absolute top-[4.375rem] z-20 [&.swiper-button-disabled]:opacity-0 right-4 max-md:hidden">
          <div className="relative">
            <div className="bg-primary-500 rounded-full w-14 h-14 drop-shadow-[0px_14px_50px_#BE57DD]"></div>
            <AngleRightBold className="h-[1.375rem] absolute left-2/4 top-2/4 transform-[translate(-50%,-50%)]" />
          </div>
        </button>
      </Swiper>
    </div>
  );
}
